import { AuthApi, Configuration } from "../../generated-client";
import "reflect-metadata";
declare const sap: any;

declare global {
	interface Window {
		BACKEND_URL?: string;
	}
}

export class AuthClient {
	public authApi: AuthApi;

	constructor() {
		const basePath =
			window.BACKEND_URL || location.origin || "http://localhost:3000";
		const config = new Configuration({
			basePath: basePath,
		});
		this.authApi = new AuthApi(config);
	}
}
